<p-dropdown class="soc-dropdown" [options]="countries" (onChange)="switchActiveLang(selectedCountry)"
    [(ngModel)]="selectedCountry" [autoDisplayFirst]=false optionLabel="name" [showClear]="false"
    placeholder="Select a Country">

    <ng-template pTemplate="selectedItem">
        <div class="d-flex justify-content-start align-items-center" *ngIf="selectedCountry">
            <img src={{selectedCountry.icon}} alt="" width="20" height="20">
            <div *ngIf="!ShowFullName" class="ms-2">{{selectedCountry.translateValue |translate | uppercase}}</div>
            <div *ngIf="ShowFullName" class="ms-2">{{selectedCountry.name |translate | uppercase}}</div>
        </div>
    </ng-template>
    <ng-template let-country pTemplate="item">
        <div class="d-flex">
            <img src={{country.icon}} width="20" height="20"/>
            <div *ngIf="!ShowFullName" class="ms-2">{{country.translateValue | translate | uppercase}}</div>
            <div *ngIf="ShowFullName" class="ms-2">{{country.name |translate | uppercase}}</div>
        </div>
    </ng-template>
</p-dropdown>